import { InjectionToken } from "@angular/core";

export interface WebVitalsEnvironment {
    core: boolean;
    other: boolean;
}

export const WEB_VITALS_ENVIRONMENT: InjectionToken<WebVitalsEnvironment> =
    new InjectionToken("WEB_VITALS_ENVIRONMENT");
